import { post} from "./httpimg";

//

export const uploadImg = p => post('api/demand/uploadImg', p); // 文件上传